import inventory from "../../../Assets/Img/inventory.webp";
import companyfounder from "../../../Assets/Img/companyfounder.webp"
import location from "../../../Assets/Img/location.webp";
import stories from "../../../Assets/Img/stories.webp";
import solution from "../../../Assets/Img/solution.webp";
import differentimage from "../../../Assets/Img/differentimage.webp";
import offerimage from "../../../Assets/Img/offerimage.webp";
import Breadcrumbs from "../../../subComponent/Breadcrumbs";
import BannerLinks from "../../../subComponent/BannerLinks";


import Data from './Data'
import ValueData from './ValueData'
import FounderData from './FounderData'
import NavBar from "../../../subComponent/NavBar";
const AboutUs = () => {
    return (
        <>
 
            <div className="background-setting inventory-banner-backkground contactus-backdrop">
                <div className="inventory-backdrop" >
                <NavBar />
                    <div className="container">
                        <div className="contact-header mx-3 mx-md-0">
                            <p className="contact-heading futura text-white-50 fs_84  m-0 pb-3 pb-md-5">About</p>
                           <p className="inventory-paragraph  text-white poppins fs_32 fw-500 pb-3 pb-md-5 m-0  ">Our Stories</p>
                          
                            <Breadcrumbs pages={['Home', 'About']} />
                            
                        </div>
                    </div>
                    <div className="contact-us-color Rounded-6 mx-3 mx-md-5 ">
                        <div className="container">
                            <div className="text-center">
                                <p class="underline-with-circle-and-dot my-5 mx-2 mx-md-0 fs_22 poppins ls_2 text-black  pt-3 pt-md-5">A Message From The Company Founder</p>
                            </div>
                            <div className="contact-us-image Rounded-6  mx-2 p-md-5 ">
                                <img src={companyfounder} width="100%" alt="Your image my-0 my-md-5" />
                            </div>
                            <div className="about-us-section pb-5 mx-3 mx-md-5 px-0 px-md-3">
                                <p className="About-us_text  text-black  ls_2 futura">Amazon was the first company to create a 1-click ordering. Today, their retail outlets does not even have a counter.</p>
                                <p className="About-us_text  text-black  ls_2 futura">How about you? What are you doing to automate your business today?</p>
                                <p className="About-us_content text-black text-end ls_2 futura fw-500">- Alwin Ng</p>
                            </div>
                            <div className="text-center">
                                <p class="underline-with-circle-and-dot mt-3 mt-md-5 fs_22 poppins ls_2 text-black  pt-3">Stories of Alwin Ng</p>
                            </div>
                            <div className="contact-us-image  mx-2 p-md-5 ">
                                <img src={stories} width="100%" alt="Your image my-5" />
                            </div>
                            <div className="about-us-section pb-5 mx-3 mx-md-5 px-0 px-md-5 ">
                                <p className="About-us_text  text-black  ls_2 futura">Alwin Ng is a technopreneur. As a curious individual, Alwin was always interested to understand how things work.</p>
                                <p className="About-us_text  text-black  ls_2 futura">
                                    In 2007, while working in his first job (in Rolls Royce HQ, UK),
                                    he started his first online shop on ebay UK after work.
                                    He started off with daily wear (polo t-shirts etc) before gradually moving towards electronic devices and gadgets.
                                    It was on ebay that Alwin started to learn web coding like html as well as basic online marketing
                                </p>
                                <p className="About-us_text  text-black  ls_2 futura">Alwin went on to become an ebay powerseller (one of ebay’s top rated seller rankings).</p>
                                <p className="About-us_text  text-black  ls_2 futura">In 2008, after joining Barclays Bank PLC, the Sub Prime Mortgage crisis became official – a.k.a. one of the largest financial crises in history. Alwin, with his combined technical and finance background, became the system go-to person.</p>

                                <p className="About-us_content text-black text-end ls_2 futura fw-500">- Read More</p>
                            </div>
                            <div className="text-center">
                                <p class="underline-with-circle-and-dot mt-3 mt-md-5 fs_22 poppins ls_2 text-black  pt-3">Alwin's Credentials</p>
                            </div>
                        </div>
                        <div className="row w-100 crdentials-section m-0 py-5 ">
                            {Data.map(each => (
                                <div className="credentials-image col-12 col-md-6  px-3 px-md-5 pb-3 ">
                                    <img src={each.Img} width="100%" alt="Your image" />
                                    <div className="inventory-header d-flex justify-content-center align-items-center flex-column py-3 py-md-5">
                                        <p className="inventory-heading  text-center text-black  fw-500">{each.heading}</p>
                                        <p className="inventory-heading  text-center text-black  fw-500">{each.text}</p>
                                    </div>

                                </div>
                            )
                            )}
                        </div>
                    </div>
                    <div className="contact-us-color Rounded-6 mx-md-5 mx-3 my-5 ">
                        <div className="container">
                            <div className="text-center">
                                <p class="underline-with-circle-and-dot mt-5 fs_22  ls_2 text-black  pt-0 pt-md-5 poppins">WHO Are We?</p>
                            </div>
                            <p className="About-us_text text-black text-center fs_22 ls_3 pt-5 poppins">"We are a solution provider which specializes in Digital Transformation".</p>
                            <div className="row company-section py-0 py-md-5 my-md-5 my-2 ">
                                <div className="col-12 col-md-7">
                                    <div className=" mx-2 mx-md-5 py-md-0 py-4">
                                        <p className="about-us_text  text-black   ls_2 futura">SmartB is grown from a team of Technology Fanatics who are passionately crazy about helping our customers grow. We aim to help all our customers become smarter through the use of IT products or services </p>
                                        <p className="about-us_text  text-black   ls_2 futura">SmartB is grown from a team of Technology Fanatics who are passionately crazy about helping our customers grow. We aim to help all our customers become smarter through the use of IT products or services </p>
                                        <p className="about-us_text  text-black   ls_2 futura">Founded in 2017, SmartB Solutions Sdn Bhd is a 100% Malaysian-owned company that offers a diverse range of Enterprise solutions that are purposefully built with SMEs in mind. Thus, making it scalable, modifiable, and extremely favoured by the SMEs.</p>
                                        <p className="about-us_text  text-black   ls_2 futura">he company started with our proprietary Enterprise Resource Planning (ERP) system. Today, we cover products and services that ranges across the manufacturing, warehousing and service sector. Our offerings to include customized systems, Warehouse Robotics, Big Data, Ai solutions, Project Management services and more. Where our customers cannot find an answer, we work with them to create a solution.</p>
                                        <p className="about-us_text  text-black   ls_2 futura fw-500">SmartB is the brand name registered under SmartB Solutions Sdn. Bhd. (1240771-A) - a Private Limited company registered in Malaysia.</p>
                                    </div>
                                </div>
                                <div className="col-12 col-md-5 form-image">
                                    <img src={solution} width="100%" alt="Your image my-5" />
                                </div>
                            </div>
                            <div className="text-center  about-border-line">
                                <p class="underline-with-circle-and-dot mt-5 pt-0 pt-md-3 fs_22 ls_2 text-black  poppins">Our Value</p>
                            </div>
                            <div className="row my-5 row-gap-3">
                                {ValueData.map(each => (

                                    <div className="col-12 col-md-6  p-4">
                                        <div className="background-setting Values" style={{ backgroundImage: `url(${each.Img})` }}>
                                            <div className="inventory-backdrop" >
                                                <div className="inventory-header d-flex justify-content-center align-items-center flex-column py-5 unHover">
                                                    <img src={each.Imgicon} width="100px" alt="Your image my-5" />
                                                    <p className="inventory-heading text-center text-white fw-700 fs_30 mb-0 mt-4 poppins">{each.heading}</p>
                                                </div>
                                                <div className="hover-content text-white text-center d-flex justify-content-center align-items-center flex-column py-5 onHovering-text">
                                                    <p className="">{each.text}</p>
                                                    <p className="">{each.descrption}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )

                                )}
                            </div>

                            <div className="text-center about-border-line mt-5 pt-0 pt-md-5">
                                <p class="underline-with-circle-and-dot  fs_22 poppins ls_2 text-black  ">Why Are We Different?</p>
                            </div>
                            <div className="contact-us-image  mx-0 mx-md-2 px-2 px-md-5 pt-2 pt-md-3 ">
                                <img src={differentimage} width="100%" alt="Your image my-5" />
                            </div>
                            <div className=" mx-3 mx-md-5 px-0 px-md-5 pb-2">
                                <p className="About-us_text  text-black  ls_2 futura">We pride ourselves in being leaner and faster in doing what others do, while remaining affordable.</p>
                                <p className="About-us_text  text-black  ls_2 futura">
                                    SmartB’s ability to combine a traditional solution (ERP) with cloud means we are also able to cater to a large customer base. Our focus is to configure our products to fit customer needs and industries of all sizes. We aim to be a leading provider of cloud services that facilitates process automation, not just in Malaysia, but throughout Asia.
                                </p>
                                <p className="About-us_text  text-black  ls_2 futura">We aim to keep up the momentum of making businesses simpler, user-friendly and automated. With a customer-centric approach, our aim is to help enterprises and businesses thrive.</p>
                            </div>
                            <div className="text-center about-border-line pt-0 pt-md-5 mt-3 mt-md-5">
                                <p class="underline-with-circle-and-dot  fs_22 ls_2 poppins text-black  ">What We Offer?</p>
                            </div>
                            <div className="contact-us-image  mx-0 mx-md-2 px-2 px-md-5 pt-2 pt-md-3 ">
                                <img src={offerimage} width="100%" alt="Your image my-5 my-md-3" />
                            </div>
                            <div className=" mx-3 mx-md-5 px-0 px-md-5 pb-5 ">
                                <p className="About-us_text text-black  ls_2 futura">We help clients digitize their complex business processes, making it easy to manage. At the same time, we also specialize in complex stock movements (especially in the manufacturing) and business process automation.
                                </p>
                                <p className="About-us_text text-black  ls_2 futura">
                                    Through our digital engineers, we aim to help clients reduce at least 50% of “wastage” while doubling your productivity.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div>

                        <div className="contact-us-color Rounded-6 mx-3 mx-md-5 ">
                            <div className="container">
                                <div className="text-center">
                                    <p class="underline-with-circle-and-dot my-5 mx-2 mx-md-0 fs_22 poppins ls_2 text-black  pt-3 pt-md-5">The Team That Makes It Happen</p>
                                </div>
                                <div className="mx-3 mx-md-5 px-0 px-md-3">
                                    <p className="about-us_descprtion text-black text-center  ls_2 futura">Welcome our dynamic mix of people from various background.
                                        The team consists of programmers, engineers, physicists and psychologist, all gathered together to make things happen.</p>
                                </div>

                                <div class="row text-center py-5">
                                    <div className="col-12 col-lg-4">
                                        <p className="poppins fs_27">12</p>
                                        <p className="futura">Hue-crew Members<br />
                                            (And Counting...)</p>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <p className="poppins fs_27">100</p>
                                        <p className="futura">Projects <br />
                                            We Finished</p>
                                    </div>
                                    <div className="col-12 col-lg-4 ">
                                        <p className="poppins fs_27">1 </p>
                                        <p className="futura">Mission,<br />
                                            Make It Memorable</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row py-5 mx-md-5 mx-3 ">
                                {FounderData.map(each => (
                                    <div className="col-12 col-md-3  p-4">
                                        <div className="inventory-header ">
                                            <img src={each.Imgfounder} width="100%" alt="Your image my-5" />
                                        </div>
                                        <div className="my-4">
                                            <p className=" text-black fw-500 py-4 m-0 futura ls_2">{each.heading}</p>
                                            <p className=" futura m-0">{each.text}</p>
                                        </div>
                                    </div>

                                )

                                )}
                            </div>
                        </div>
                        <div className="Home_Background background-setting py-5" >
                            <p className="futura fs_8 text-white m-0 text-center">Home</p>
                        </div>
                        <BannerLinks />
                    </div>
                </div>
            </div>
        </>
    )
}
export default AboutUs